import { render, staticRenderFns } from "./ngo-registration-form.vue?vue&type=template&id=081424ce&scoped=true&"
import script from "./ngo-registration-form.vue?vue&type=script&lang=js&"
export * from "./ngo-registration-form.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registration-form.vue?vue&type=style&index=0&id=081424ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081424ce",
  null
  
)

export default component.exports